// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditMedication_modal__1tPBh"};